import { QueryClient } from "react-query";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: (failureCount, error: any) => {
                // deactivate retry if 401
                if (error?.status === 401) return false;
                // retry 3 times
                return failureCount < 3;
            },
        },
    },
});

export default queryClient